import copyToClipboard from './copy-to-clipboard-func'

document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.content-clipboard');
  const tooltips = document.querySelectorAll('.tooltip__body-hint-copy');
  const socialBlock = document.querySelector('.content__info-social');

  const share = document.querySelector('.content__share-button');
  share.addEventListener('click', async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: window.location.href
        });
      } catch (err) {
        console.log(err)
      }
    } else {
      if (socialBlock.style.display === 'flex') {
        socialBlock.style.display = 'none'
      } else {
        socialBlock.style.display = 'flex'
      }
    }
  })

  triggers.forEach((item, i) => {
    item.addEventListener('click', async () => {
      try {
        await copyToClipboard(window.location.href);
      } catch (err) {
        console.error(err);
      }
      // tooltips[i].style.display = 'flex';
      item.querySelector('img').src = '/static/news/img/base/check_mark.png';
      let oldTitle = item.title;
      item.title = item.dataset.copiedTitle;

      setTimeout(() => {
        item.querySelector('img').src = '/static/news/img/base/share.svg';
        item.title = oldTitle;
        // tooltips[i].style.display = 'none';
      }, 2000)
    })
  })
});